import type { MutableRefObject } from "react";

export function scrollElementOutVisibility(
  elementId: string,
  scrollableRef: MutableRefObject<HTMLDivElement | null>,
  safeOffset: number,
): void {
  const element = window.document.getElementById(elementId);
  const scrollable = scrollableRef.current;

  if (element instanceof HTMLElement && scrollable instanceof HTMLElement) {
    const elementLeft = element.offsetLeft - safeOffset;
    const elementRight = element.offsetLeft + element.clientWidth + safeOffset;

    const elementLeftInView =
      elementLeft > scrollable.scrollLeft &&
      elementLeft < scrollable.scrollLeft + scrollable.clientWidth;

    const elementRightInView =
      elementRight > scrollable.scrollLeft &&
      elementRight < scrollable.scrollLeft + scrollable.clientWidth;

    if (!elementLeftInView || !elementRightInView) {
      window.setTimeout(() => {
        scrollable.scrollTo({
          left:
            element.offsetLeft -
            (scrollable.clientWidth / 2 - element.clientWidth / 2),
          behavior: "smooth",
        });
      }, 1000 / 60);
    }
  }
}
